<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-color`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 26.604c0-6.586-5.162-13.706-15.997-21.185C13.164 12.916 8 20.038 8 26.604c0 8.836 7.163 16 16 16s16-7.164 16-16zM25.113 1.338C37.704 9.76 44 18.182 44 26.604c0 11.045-8.954 20-20 20s-20-8.955-20-20C4 18.202 10.296 9.78 22.888 1.339a2 2 0 012.225-.001z"/></svg>
</template>
<script>

export default {
  name: 'IconColor',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
